<div class="request-form-content">
  <div class="uav-layout-content">

    <div class="flex flex-row gap-1">
      <div class="col-3">
        <ng-container>
          <!-- First section - Request information -->
          <div class="form-section">
            <div class="field-group">
              <div class="col-5">
                <label class="request-label">{{ 'Request number' | translate }}</label>
              </div>
              <div class="not-edit col-7 ">
                {{ _bid.number }}
              </div>
            </div>

            <div class="field-group ">
              <div class="col-5">
                <label class="request-label">{{ 'Date of creation' | translate }}</label>
              </div>
              <div class="not-edit col-7">
                @if (formData.createAt) {
                  {{ formData.createAt | dateFormatLang:tr.currentLang }}
                  <!--                  {{formData.createAt}}-->
                } @else {
                  {{ '--/--/--  --:--:--' }}
                }
              </div>
            </div>

            <div class="field-group">
              <div class="col-5">
                <label class="request-label">{{ 'Date of update' | translate }}</label>
              </div>
              <div class="not-edit col-7">
                @if (formData.lastUpdateAt) {
                  {{ formData.lastUpdateAt | dateFormatLang:tr.currentLang }}
                } @else {
                  {{ '--/--/--  --:--:--' }}
                }
              </div>
            </div>

            <div class="field-group ">
              <div class="col-5">
                <label class="request-label">{{ 'Status' | translate }}</label>
              </div>
              <div class="not-edit col-7">
                {{ statusOptions | getById:formData.bidState:'name':tr.currentLang }}
              </div>
            </div>

            <div class="field-group">
              <div class="col-5">
                <label class="request-label">{{ 'Deadline' | translate }}</label>
              </div>
              <div class="col-7">
                <app-date-picker
                  [(ngModel)]="formData.deadlineDate"
                  placeholder="Choose a date">
                </app-date-picker>
              </div>
            </div>

            <div class="field-group ">
              <div class="col-5">
                <label class="request-label">{{ 'Customer' | translate }}</label>
              </div>

              <!--              <div class="not-edit col-7">-->
              <!--                {{ formData.customer || '-/-' }}-->
              <!--              </div>-->
              <div class="col-7">
                <msf-input
                  [(model)]="formData.customer"
                  placeholder="{{ 'Enter customer' | translate }}"
                />

              </div>
            </div>

            <p-divider layout="horizontal"></p-divider>

            <div class="field-group">
              <div class="col-5">
                <label>{{ 'Region' | translate }}</label>
              </div>
              <div class="col-7">
                <msf-select-paginated
                  [(model)]="formData.regionId"
                  [service]="regionService"
                  (modelChange)="onRegionChange($event)"
                  serviceMethod="dictionariesRegionGetByQueryPost"
                  searchBy="names"
                  placeholder="Выберите или введите регион"
                />
              </div>
            </div>

          </div>

          <div class="form-section">

            <div class="field-group">
              <div class="col-5">
                <label>{{ 'Author' | translate }}</label>
              </div>
              <div class="p-disabled col-7">
                {{ author || '-/-' }}
              </div>
            </div>
            <div class="field-group ">
              <div class="col-5">
                <label>{{ 'Changed' | translate }}</label>
              </div>
              <div class="p-disabled col-7">
                {{ lastUpdateUser || '-/-' }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <p-divider layout="vertical"></p-divider>
      <div class="col-3">
        <div class="field-group coordinates-field-group align-items-baseline">
          <label>{{ 'Coordinates' | translate }}</label>
          <div class=" flex-column gap-4">
            <div class="mb-2">
              <msf-input
                [(model)]="formData!.lat"
                (onBlur)="onCoordinatesChange()"
                type="number"
                placeholder="{{'lat' | translate}}"
                step="any"
                [maxFractionDigits]="10"
                class="coordinates-input"
              />
            </div>
            <msf-input
              [(model)]="formData!.lng"
              (onBlur)="onCoordinatesChange()"
              type="number"
              placeholder="{{'lng' | translate}}"
              step="any"
              [maxFractionDigits]="10"
              class="mt-4"
            />
          </div>
        </div>

        <div class="field-group flex flex-column align-items-start">
          <label>{{ 'Task description' | translate }}</label>

          <app-textarea
            class="mt-2"
            placeholder="{{ 'Text' | translate }}"
            [(ngModel)]="formData.description"
          ></app-textarea>
        </div>

        <div class="field-group flex   mt-4 flex-column align-items-start">
          <label>{{ 'Task content' | translate }}</label>
          <msf-select-paginated
            class="mt-2"
            style="width: 100%;"
            [(model)]="formData.bidTypeId"
            [service]="bidTypeService"
            serviceMethod="dictionariesBidTypeGetByQueryPost"
            searchBy="names"
            placeholder="Task content"
          />
        </div>

        <p-divider layout="horizontal"></p-divider>

        <div class="field-group  mt-4">
          <div class="flex flex-column gap-3 align-items-start">
            <div>
              <app-checkbox
                [(ngModel)]="formData.active"
                [label]="'Publish'"
              >
              </app-checkbox>
            </div>
            <div>
              <app-checkbox
                [(ngModel)]="formData.archive"
                [label]="'Archive'">
              </app-checkbox>
            </div>
          </div>
        </div>

        @if (formData?.id) {
          <div class="field-group flex align-items-center">
            <label class="link-label"
                   (click)="showModalDownload = true">{{ 'Survey results' | translate }}
            </label>
          </div>
        }
        <app-dialog
          [(visible)]="showModalDownload"
          width="50vw"
          height="75vw"
          [modal]="true"
          [closable]="true"
          [showFooter]="true"
          header="{{ 'Survey results' | translate }}"
          (onShow)="onDialogShow()"
        >
          <div class="flex flex-column h-full align-items-center justify-content-center">



            @if (!formData?.fileResultId) {
              <!--              <app-openlayers-map-->
                <!--                [height]="'100%'"-->
                <!--                [center]="[formData?.lng, formData?.lat]"-->
                <!--                [zoom]="14"-->
                <!--                [satellite]="true"-->
                <!--              ></app-openlayers-map>-->
              @if (showResultPreview) {
                Preview ...
              }@else{
              <p>{{ 'Survey results ready' | translate }}</p>
              <span style="color: var(--color-grey-font)">ZIP 42 Mb</span>
            }
            } @else {
              <p>{{ 'Survey results not found' | translate }}</p>
            }
          </div>
<!--          [disabled]="!formData?.fileResultId || downloading"-->
          <ng-template #footer>
            <button
              pButton
              type="button"
              severity="secondary"
              [label]=" 'Preview' | translate"
              (click)="showResultPreview = true"
              [disabled]="!formData?.fileResultId || showResultPreview"
            ></button>
            <button
              pButton type="button"
              label="{{ 'Download' | translate }}"
              (click)="downloadBidFile()"
              icon="{{downloading?'pi pi pi-spin pi-spinner':'pi pi-download'}}"
              [disabled]="!formData?.fileResultId || downloading"
            class="p-button-primary"
            ></button>
          </ng-template>
        </app-dialog>


        <!-- Comment Section -->
        <div class="field-group   mt-4 align-items-start flex flex-column">
          <label>{{ 'Comment' | translate }}</label>
          <app-textarea
            class="mt-2"
            placeholder="{{ 'Текст' | translate }}"
            [(ngModel)]="formData.comment"
          ></app-textarea>
        </div>
        <div class="form-actions">
          <app-secondary-button
            [title]="'Cancel bid'"
            [disable]="isCanceling()"
            [loading]="isCanceling()"
            (action)="cancel.emit()">
          </app-secondary-button>
          <app-save-button
            [isSaving]="isSaving()"
            width="auto"
            (save)="saveRequest()">
          </app-save-button>
        </div>

      </div>

      <p-divider layout="vertical"></p-divider>

      <div class="map-container">
        <mfs-request-openlayers-map-2
            #groundMap
            appDetectedFieldsLayer
            [height]="'100%'"
            [center]="[formData?.lat, formData?.lng]"
            [zoom]="14"
            [drawingMode]="true"
            (markerClick)="onMarkerClick($event)"
            [polygonJson]="formData.polygonJson"
            [(geometry)]="formData.polygon"
        >
        </mfs-request-openlayers-map-2>
      </div>
    </div>
  </div>
</div>


<div *ngIf="showPointModalValue"
     style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 9999; display: flex; align-items: center; justify-content: center;"
     (click)="cancelPointChange()"
>
  <div
    style="background: white; padding: 20px; border-radius: 8px; min-width: 400px; box-shadow: 0 4px 20px rgba(0,0,0,0.3);"
    (click)="$event.stopPropagation()">
    <h3 style="margin: 0 0 15px 0;" class="map-point-modal">{{ 'Изменить точку?' | translate }}</h3>
    <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px;">
      <button
        pButton
        type="button"
        severity="secondary"
        [label]=" 'Cancel' | translate"
        (click)="cancelPointChange()"
      ></button>
      <button pButton type="button" label="{{ 'Подтвердить' | translate }}" class="p-button-primary"
              (click)="confirmPointChange()">
      </button>
    </div>
  </div>
</div>


<app-dialog
  [(visible)]="showContinueWithoutFiledDialog"
  header="Confirm"
  width="450px"
  [modal]="true"
  [closable]="true"
  [showFooter]="true"
>
  <div style="display: flex; align-items: center;">
<!--    <i class="pi pi-question-circle" style="font-size: 3rem; margin-right: 1rem;"></i>-->
    <span>{{ 'Field not found. Continue' | translate }} ?</span>
  </div>
  <ng-template #footer>
    <button pButton type="button" [label]="'No' | translate" class="p-button-text p-button-cancel-btn"
            (click)="notContinueWithoutField()"></button>
    <button pButton type="button" [label]="'Yes' | translate" class="p-button-danger"
            (click)="continueWithoutField()"></button>
  </ng-template>
</app-dialog>

<app-dialog
  [(visible)]="showContinueWithoutVarietyDialog"
  header="Confirm"
  width="450px"
  [modal]="true"
  [closable]="true"
  [showFooter]="true"
>
  <div style="display: flex; align-items: center;">
    <i class="pi pi-question-circle" style="font-size: 3rem; color: var(--red-500); margin-right: 1rem;"></i>
    <span>{{ 'Sowing not found. Continue' | translate }} ?</span>
  </div>
  <ng-template #footer>
    <button pButton type="button" [label]="'No' | translate" class="p-button-text p-button-cancel-btn"
            (click)="notContinueWithoutField()"></button>
    <button pButton type="button" [label]="'Yes' | translate" class="p-button-danger"
            (click)="continueWithoutField()"></button>
  </ng-template>
</app-dialog>
